export default "__VITE_ASSET__B1k8bSz6__"